'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bitterbal = require('./Bitterbal');

var _Bitterbal2 = _interopRequireDefault(_Bitterbal);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var sendWhenIdle = window.requestIdleCallback || window.setTimeout;

var Analytics = function () {
  function Analytics() {
    _classCallCheck(this, Analytics);

    this.cookieConsentGiven = document.cookie.indexOf("wl-consent-saved=true") >= 0;
    this.bitterbal = new _Bitterbal2.default();
  }

  _createClass(Analytics, [{
    key: 'shouldPush',
    value: function shouldPush() {
      return !window.isPreRender;
    }
  }, {
    key: 'pushBitterbal',
    value: function pushBitterbal(event) {
      var _this = this;

      sendWhenIdle(function () {
        if (_this.shouldPush()) {
          _this.bitterbal.push(event);
        }
      });
    }
  }, {
    key: 'pushGtm',
    value: function pushGtm() {
      var _this2 = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      sendWhenIdle(function () {
        if (window.dataLayer) {
          if (_this2.shouldPush()) {
            var _window$dataLayer;

            (_window$dataLayer = window.dataLayer).push.apply(_window$dataLayer, args);
          }
        } else {
          console.warn('No dataLayer object');
        }
      });
    }
  }, {
    key: 'push',
    value: function push() {
      this.pushGtm.apply(this, arguments);
      this.pushBitterbal.apply(this, arguments);
    }
  }, {
    key: 'addTool',
    value: function addTool() {
      // backwards compatibility
      console.warn('addTool - deprecated');
    }
  }, {
    key: 'reset',
    value: function reset() {
      // backwards compatibility
      console.warn('reset - deprecated');
    }
  }, {
    key: 'getPayloadWithStandardCategories',
    value: function getPayloadWithStandardCategories() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var eventCategory = typeof args[0] === 'string' ? args[0] : '-';
      var eventAction = typeof args[1] === 'string' ? args[1] : '-';
      var eventLabel = typeof args[2] === 'string' ? args[2] : '-';
      var eventValue = typeof args[3] === 'number' ? args[3] : 1;
      var objs = (args ? args.filter(function (x) {
        return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object';
      }) : {}).reduce(function (o, i) {
        return _extends({}, o, i);
      }, {});

      var objToSend = Object.assign({}, eventCategory && { eventCategory: eventCategory }, eventAction && { eventAction: eventAction }, eventLabel && { eventLabel: eventLabel }, eventValue && { eventValue: eventValue }, objs);

      return objToSend;
    }
  }, {
    key: 'trackJsMetaData',
    value: function trackJsMetaData(keyName, value) {
      sendWhenIdle(function () {
        if (window.trackJs && typeof window.trackJs.addMetadata === 'function') {
          window.trackJs.addMetadata(keyName, value);
        }
      });
    }
  }, {
    key: 'setApplicationVersion',
    value: function setApplicationVersion(version, platform, environment, cobranded) {
      this.push({ event: 'setApplicationVersion', payload: { version: version, platform: platform, environment: environment, cobranded: cobranded } });
      this.trackJsMetaData('platform', platform);
      this.trackJsMetaData('environment', environment);
      this.bitterbal.addToSession({ version: version, platform: platform, environment: environment });
    }
  }, {
    key: 'track',
    value: function track() {
      this.push({ event: 'event', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'milestone',
    value: function milestone() {
      this.push({ event: 'event', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'performanceMilestone',
    value: function performanceMilestone(name, endTimeFunc, avgTimeFunc, loadTimeTargetInSeconds) {
      this.pushGtm({ event: 'performanceMilestone', payload: { name: name, endTimeFunc: endTimeFunc, avgTimeFunc: avgTimeFunc, loadTimeTargetInSeconds: loadTimeTargetInSeconds } });
    }
  }, {
    key: 'page',
    value: function page(path, args) {
      this.push({ event: 'page', payload: this.getPayloadWithStandardCategories({ path: path, args: args }) });
    }
  }, {
    key: 'getCookieConsent',
    value: function getCookieConsent() {
      return this.cookieConsentGiven;
    }
  }, {
    key: 'setCookieConsent',
    value: function setCookieConsent(cookieConsentGiven) {
      this.cookieConsentGiven = cookieConsentGiven;
      this.push({ event: 'cookieConsent', payload: { cookieConsentGiven: cookieConsentGiven } });
      this.bitterbal.addToPersisted({ cookieConsentGiven: cookieConsentGiven });
    }
  }, {
    key: 'setAdvertisementConsent',
    value: function setAdvertisementConsent(advertisementConsentGiven) {
      this.push({ event: 'advertisementConsent', payload: { advertisementConsentGiven: advertisementConsentGiven } });
      this.bitterbal.addToPersisted({ advertisementConsentGiven: advertisementConsentGiven });
    }
  }, {
    key: 'setSocialConsent',
    value: function setSocialConsent(socialConsentGiven) {
      this.push({ event: 'socialConsent', payload: { socialConsentGiven: socialConsentGiven } });
      this.bitterbal.addToPersisted({ socialConsentGiven: socialConsentGiven });
    }
  }, {
    key: 'identify',
    value: function identify() {
      this.pushGtm({ event: 'identify', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
      var account = (arguments.length <= 0 ? undefined : arguments[0]) ? arguments.length <= 0 ? undefined : arguments[0] : undefined;
      if (!account) return;
      this.pushBitterbal({ event: 'identify', payload: { id: account.id } });
      this.bitterbal.addToPersisted({ account: {
          id: account.id
        } });
    }
  }, {
    key: 'logDebug',
    value: function logDebug() {
      this.push({ event: 'debug', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'logError',
    value: function logError() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      this.pushGtm({ event: 'error', payload: this.getPayloadWithStandardCategories.apply(this, args) });
      if (args[0] instanceof Error) {
        this.bitterbal.handleError(args[0]);
      }
      console.error('error logged by application', args);
    }
  }, {
    key: 'onHomePage',
    value: function onHomePage() {
      this.push({ event: 'homepage', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'appOpen',
    value: function appOpen() {
      this.push({ event: 'appOpen', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'languageChanged',
    value: function languageChanged(lang) {
      this.push({ event: 'languageChanged', payload: { lang: lang } });
    }
  }, {
    key: 'becomePromoter',
    value: function becomePromoter() {
      this.push({ event: 'becomePromoter', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'becomeInvitee',
    value: function becomeInvitee() {
      this.push({ event: 'becomeInvitee', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'inviteOthers',
    value: function inviteOthers() {
      this.push({ event: 'inviteOthers', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'onTag',
    value: function onTag() {
      this.push({ event: 'onTag', payload: this.getPayloadWithStandardCategories.apply(this, arguments) });
    }
  }, {
    key: 'viewedList',
    value: function viewedList(experienceList, list) {
      this.pushGtm({ event: 'viewedList', payload: { experienceList: experienceList, list: list } });
      var experienceListWithIds = experienceList.map(function (e) {
        return e.id;
      });
      this.pushBitterbal({ event: 'viewedList', payload: { experienceListWithIds: experienceListWithIds, list: list } });
    }
  }, {
    key: 'clickedExperience',
    value: function clickedExperience(experience, list, position) {
      this.pushGtm({ event: 'clickedExperience', payload: { experience: experience, list: list, position: position } });
      this.pushBitterbal({ event: 'clickedExperience', payload: { experience: { id: experience.id }, list: list, position: position } });
    }
  }, {
    key: 'viewedExperience',
    value: function viewedExperience(experience, list, position) {
      this.pushGtm({ event: 'viewedExperience', payload: { experience: experience, list: list, position: position } });
      this.pushBitterbal({ event: 'viewedExperience', payload: { experience: { id: experience.id }, list: list, position: position } });
    }
  }, {
    key: 'addToCartTrip',
    value: function addToCartTrip(trip) {
      var _this3 = this;

      this.once('addToCartTrip.' + trip.id, function () {
        _this3.pushGtm({ event: 'addToCartTrip', payload: { trip: trip } });
        _this3.pushBitterbal({ event: 'addToCartTrip', payload: { trip: { id: trip.id } } });
      });
    }
  }, {
    key: 'checkoutTrip',
    value: function checkoutTrip(trip) {
      var _this4 = this;

      var cookieTripId = trip.id || trip.experience_id + '-' + trip.trip_date;

      this.once('checkoutTrip.' + cookieTripId, function () {
        _this4.pushGtm({ event: 'checkoutTrip', payload: { trip: trip } });
        _this4.pushBitterbal({ event: 'checkoutTrip', payload: { trip: { id: trip.id } } });
      });
    }
  }, {
    key: 'tripPaid',
    value: function tripPaid(trip) {
      var _this5 = this;

      this.once('tripPaid.' + trip.id, function () {
        _this5.pushGtm({ event: 'tripPaid', payload: { trip: trip } });
        _this5.pushBitterbal({ event: 'tripPaid', payload: { trip: { id: trip.id } } });
      });
    }
  }, {
    key: 'once',
    value: function once(key, fn) {
      var done = _jsCookie2.default.get('wlanalytics.' + key);
      if (!done) {
        fn();
        _jsCookie2.default.set('wlanalytics.' + key, true, { expires: 1 });
      }
    }
  }, {
    key: 'registerGlobal',
    value: function registerGlobal() {
      var _this6 = this;

      if (window.analBuffer) {
        window.analBuffer.push = function () {
          for (var _len4 = arguments.length, events = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            events[_key4] = arguments[_key4];
          }

          events.forEach(function (event) {
            return _this6.pushBitterbal(event);
          });
        };
        window.analBuffer.forEach(function (event) {
          return _this6.pushBitterbal(event);
        });
      }
    }
  }]);

  return Analytics;
}();

exports.default = Analytics;